import React from 'react'
import { SVGProps } from './types'

export const NavGifts: React.FC<SVGProps> = ({
  size = 24,
  color = 'currentColor',
  onClick,
  strokeWidth = 2,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      onClick={onClick && (() => onClick())}
    >
      <path
        d="M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z"
        fill="none"
      />
      <circle cx="7.5" cy="7.5" r=".5" fill="none" />
    </svg>
  )
}
